import AsyncRequest, {GetDataParameters, PostDataParameters} from "./async-request";
import {Alert, ToastParameters} from "./alert";
import {addMinutes, differenceInDays} from "date-fns";
import {AlertType} from "./default-constants";
import {IndexedDbHelper} from "./indexed-db-helper";
import Tr from "vanillajs-datepicker/locales/tr";
import fa from "vanillajs-datepicker/locales/fa";

class LayoutSnippetClass {
	instance = {};

	constructor() {
		this.init();
	}

	windowLoad() {
		// $.fn.select2.defaults.set("theme", "bootstrap4");

		this.#initDatePickers();
	}


	#initDatePickers() {

		let options = {
			format: 'dd/mm/yyyy',
			startView: 0,
			language:'pt-br',
			zIndexOffset:2000,
			autoClose: true
		}

		$(".date-picker").each(function(){$(this).datepicker(options)});
		$('.input-daterange input').each(function () {
			$(this).datepicker(options);
		});

		$('input.date-range').each((i, o) => {
			let obj = $(o);
			let specificOptions = {...options, ...{
				minViewMode: 0,
				maxViewMode: 2,
				multidate: true,
				multidateSeparator: " até ",
				beforeShowDay: function (date) {
					return highlightRange($(obj), date)
				}
			}};
			
			obj.datepicker(specificOptions).on("changeDate", function (event) {
				let dates = event.dates;
				let elem = $(event.currentTarget);
				let maxDays = elem.data('selected-dates-max-days') ?? 30;

				if (elem.data("selected-dates") === dates.join(", ")) return;

				if (dates.length > 2) dates = dates.splice(dates.length - 1);

				if (dates.length === 2) {
					let daysCount = differenceInDays(dates[1], dates[0]);
					if (daysCount > maxDays) {
						dates = [dates[0]];
						Alert.showToast(new ToastParameters({
							alertType: AlertType.WARNING,
							autohide: true,
							delayMs: 5000,
							header: 'Período inválido',
							message: `Você selecionou ${daysCount} dias. <br>Selecione até ${maxDays} dias e tente novamente.`
						}))
					}
				}

				dates.sort(function (a, b) {
					return new Date(a).getTime() - new Date(b).getTime()
				});
				elem.data("selected-dates", dates.join(", ")).datepicker('setDates', dates);
			});
		})

		function highlightRange(element, date) {
			var selectedDates = element.datepicker('getDates');
			if (selectedDates.length === 2 && date >= selectedDates[0] && date <= selectedDates[1]) {
				return 'highlighted';
			}
			return '';
		}

	}

	async documentLoad() {
 
		window.isTelemetryActive = await IndexedDbHelper.listOrCreate('telemetry', async function(){
			return false;
		}, addMinutes(new Date(), 5));

		await this.setTelemetryState();

		this.#bindEvents();
		//await Promise.all([this.getVersion(), this.getUser()]);

		$("input[type='checkbox']").parent('.toggle').addClass("w-100");
		// $("select[class~='select2']").select2({
		// 	width: '100%'
		// });
		// // Initialize Select2 using AMD and the custom DataAdapter
		// $.fn.select2.amd.require(['CustomDataAdapter'], function (CustomDataAdapter) {
		// 	$("select[data-bsh-helper='select2'][data-bsh-select2-source='ajax']").select2({
		// 		dataAdapter: CustomDataAdapter,
		// 		placeholder: 'Select an item'
		// 	});
		// });
		// // Initialize Select2 with custom DataAdapter
		//	
		// $("select[data-bsh-helper='select2'][data-bsh-select2-source!='ajax']").select2({
		// 	width: '100%'
		// });
	}
		
	#bindEvents() {
		this.instance.controls.btnSignOut.on('click', async (e) => {
			await this.onBtnDisconnectUserClick(e);
		});
		this.instance.controls.btnTelemetry.on('click', async (e) => {
			await this.onBtnTelemetryUserClick(e);
		})
		// this.instance.controls.btnConnectUser.on('click', async (e) => {
		// 	await this.onBtnConnectUser(e);
		// })
	}

	async onBtnConnectUser() {
		window.location = "/account/Login";
	}

	async onBtnTelemetryUserClick() {
		await this.toggleTelemetryState();
	}
	async toggleTelemetryState() {
		if(window.isTelemetryActive) {
			window.isTelemetryActive = false;
			await this.setTelemetryState();
			await IndexedDbHelper.updateOrReplace('telemetry', async function(){
				return true;
			}, addMinutes(new Date(), 20));
			Alert.showToast(new ToastParameters({header: 'Sucesso', message:'Telemetria desativada', alertType: AlertType.SUCCESS, autohide: true, delayMs: 5000}))
		}
		else{
			window.isTelemetryActive = true;
			await this.setTelemetryState();
			await IndexedDbHelper.updateOrReplace('telemetry', async function(){
				return false;
			}, addMinutes(new Date(), 5));
			Alert.showToast(new ToastParameters({header: 'Sucesso', message:'Telemetria ativada', alertType: AlertType.SUCCESS, autohide: true, delayMs: 5000}))
		}		
	}
	async setTelemetryState() {
		if(window.isTelemetryActive){
			this.instance.controls.btnTelemetry.addClass("text-bg-danger").removeClass("text-bg-success");			
		}	
		else{
			this.instance.controls.btnTelemetry.addClass("text-bg-success").removeClass("text-bg-danger");						
		}
	}
	
	
	async onBtnDisconnectUserClick() {
		let url = '/components/account/logout';

		Alert.confirm({
			header: 'Confirmar logout',
			message: "Tem certeza de que deseja desconectar? <br>Isto irá te desconectar de todas as sessões abertas.",
			onOkClick: async () => {
				let result = await AsyncRequest.postDataV2(new PostDataParameters({
					url,
					loading: true
				}));

				if (result.isSuccess) {
					window.location = result.data.logoutUrl;
				}
			},
			okLabelText: "Ok, desconectar",
			cancelLabelText: "Cancelar"
		});
	}

	async getUser() {
		let url = '/components/account/get-user-data';

		this.instance.controls.lblUsername.html("Não Autenticado");
		this.instance.controls.btnDisconnectUser.addClass("d-none");
		this.instance.controls.btnConnectUser.removeClass("d-none");

		let result = await AsyncRequest.getData(new GetDataParameters({
			url,
			loading: false
		}));

		if (result.isSuccess && result.data) {
			this.instance.controls.lblUsername.html(`Olá, ${result.data.name}`);
			this.instance.controls.btnDisconnectUser.removeClass("d-none");
			this.instance.controls.btnConnectUser.addClass("d-none");
		}
	}

	async getVersion() {
		let url = '/components/layout/get-version';

		let result = await AsyncRequest.getData(new GetDataParameters({
			url,
			loading: false
		}));

		if (result.isSuccess && result.data) {
			this.instance.controls.lblVersion.html(result.data.productVersion).attr("title", (result.data.productFullVersion));
		}
	}

	init() {
		this.instance = {
			controls: {
				btnSignOut: $("#btnSignOut"),
				btnTelemetry: $("#btnTelemetry"),
				// lblUsername: $("#_sharedLblUsername"),
				// btnDisconnectUser: $("#_sharedBtnDisconnectUser"),
				// btnConnectUser: $("#_sharedBtnConnectUser")
			}
		}

		if(window.storeId){
			IndexedDbHelper.registerIndexedDb(`GrowthV2_${window.storeId}`);			
		}		

		$(window).ready(async ()=>{
			await this.documentLoad();
		});
	}

}

export const LayoutSnippet = new LayoutSnippetClass()
